import {
	Component,
	forwardRef,
	Input,
	ViewChild,
	ElementRef,
} from '@angular/core';
import { touchControl } from 'src/shared/utilities/utility-functions';
import { SelfDestruct } from 'src/shared/utilities/self-destruct';
import {
	ControlValueAccessor,
	FormControl,
	NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import * as moment from 'moment';
import { BACKSPACE_KEY } from 'src/shared/constants';

@Component({
	selector: 'rpshared-date-picker',
	templateUrl: './date-picker.component.html',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => RpDatePickerComponent),
			multi: true,
		},
	],
})
export class RpDatePickerComponent extends SelfDestruct
	implements ControlValueAccessor {
	private _required = false;
	@Input()
	get required(): boolean {
		return this._required;
	}
	set required(value: boolean) {
		this._required = coerceBooleanProperty(value);
	}

	private _clearable = false;
	@Input()
	get clearable(): boolean {
		return this.dateControl.value && this._clearable;
	}
	set clearable(value: boolean) {
		this._clearable = coerceBooleanProperty(value);
	}

	@Input() placeholder: string;
	@Input() hint: string;

	dateControl = new FormControl('') as FormControl;

	@ViewChild('dateInput')
	dateInput: ElementRef;

	constructor() {
		super();
	}

	// model --> view
	writeValue(value: string | moment.Moment): void {
		if (value) {
			this.dateControl.setValue(value, { emitEvent: false });
		} else {
			this.dateControl.reset('', { emitEvent: false });
		}
	}

	// view --> model
	registerOnChange(fn: (value: string | moment.Moment) => void) {
		this.dateControl.valueChanges
			.pipe(takeUntil(this.destroyed))
			.subscribe(fn);
	}

	clearValue(): void {
		this.dateControl.reset();
		setTimeout(() => this.dateInput.nativeElement.blur());
	}

	registerOnTouched(fn: () => void) {
		this.onTouched = touchControl(this.dateControl)(fn);
	}

	onTouched: () => void = () => {};

	onKeyUp(key: string) {
		if (key === BACKSPACE_KEY) {
			this.dateControl.reset('');
		}
	}
}
